module.exports = __webpack_public_path__ + "static/media/s_v10_2.9ddfef1d.mp3";